import { Group } from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { IconCloudUpload, IconUpload, IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './ImageDropzone.module.scss';
import { Props } from './ImageDropzone.types';

const ImageDropzone = ({ label, subtitle, ...props }: Props) => {
  const { t } = useTranslation();

  return (
    <Dropzone maxSize={5 * 1024 ** 2} accept={IMAGE_MIME_TYPE} multiple={false} {...props}>
      <Group justify="center" mih={138} style={{ pointerEvents: 'none' }}>
        <Dropzone.Accept>
          <IconUpload size={52} color="var(--mantine-color-blue-6)" stroke={1.5} />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX size={52} color="var(--mantine-color-red-6)" stroke={1.5} />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <IconCloudUpload size={52} color="var(--mantine-color-dimmed)" stroke={1.5} />
        </Dropzone.Idle>

        <div>
          <div className={styles.title}>
            {label ??
              t('upload.image.title', 'Faites glisser votre photo ou parcourez vos fichiers')}
          </div>
          <div className={styles.subtitle}>
            {subtitle ??
              t(
                'upload.image.subtilte',
                'Seuls les fichiers .jpg et.png sont autorisés. Max 5 MB.'
              )}
          </div>
        </div>
      </Group>
    </Dropzone>
  );
};

export default ImageDropzone;
